var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 208,
    viewBox: "0 0 190 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.577,
    cy: 146.866,
    r: 122.447,
    fill: "#DEF2F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4563,
    cy: 63.5662,
    r: 62.8167,
    fill: "#FFE7ED",
    fillOpacity: 0.63
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contactBg.c7feeeb64c4272c05697aca7bb7bf863.svg";